<!-- 2 columns form -->
<form name="saleform" [formGroup]="saleForm" novalidate>
  <div class="panel panel-flat">
    <div class="panel-heading">
      <h5 class="panel-title">Equb Sales</h5>
      <div class="heading-elements">
        <ul class="icons-list">
          <li>
            <a data-action="reload" (click)="reset()"></a>
          </li>
        </ul>
      </div>
      <hr class="divider">
    </div>

    <div class="panel-body">

      <div class="row">
        <div class="col-md-7">


          <fieldset>
            <legend class="text-semibold">
              <i class="icon-list position-left"></i> Sales
            </legend>
            <table class="table datatable-column-search-inputs">
              <thead>
                <tr>
                  <th>Seller</th>
                  <th>Buyer</th>
                  <th>Min Offer</th>
                  <th>Sold Amount</th>
                  <th>Commission</th>
                  <th>Status</th>
                  <th>Remark</th>
                  <th class="text-center">Actions</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  *ngFor="let sale of sales | paginate: { id: 'sales',itemsPerPage: itemsPerPage,currentPage: currentPage,totalItems: totalItems }">
                  <td>{{sale.seller.data.username}}</td>
                  <td>{{sale?.buyer?.data?.username}}</td>
                  <td>{{sale?.min_offer}} ETB</td>
                  <td>{{sale?.sold_price}} ETB</td>
                  <td>{{sale?.commission_amount}} ETB - {{sale?.commission_percentage}}</td>
                  <td>
                    <span class="label label-block label-warning"
                      *ngIf="sale.status === 'Pending' || sale.status === 'pending'">{{sale.status}}</span>
                    <span class="label label-block bg-teal"
                      *ngIf="sale.status === 'Sold' || sale.status === 'sold'">{{sale.status}}</span>
                  </td>
                  <td>{{sale.remark}}</td>
                  <td class="text-center">
                    <ul class="icons-list">
                      <li class="dropdown">
                        <a href="" class="dropdown-toggle" data-toggle="dropdown">
                          <i class="icon-menu9"></i>
                        </a>
                        <ul class="dropdown-menu dropdown-menu-right">
                          <li>
                            <!--  <a href="" [routerLink]="['/saleadd']" [queryParams]="{'id':sale.id}"> -->
                            <a href="javascript:void(0);" (click)="editSale(sale)">
                              <i class="icon-file-pdf"></i>Update</a>
                          </li>
                          <li>
                            <a href="">
                              <i class="icon-file-excel"></i>Delete</a>
                          </li>
                          <li class="dropdown-submenu dropdown-submenu-left">
                            <a href="javascript:void(0);">Change Status</a>
                            <ul class="dropdown-menu">
                              <li>
                                <a (click)="changeStatus(sale,'pending')">
                                  <i class="icon-shuffle"></i> Pending</a>
                              </li>
                              <li>
                                <a (click)="changeStatus(sale,'sold')">
                                  <i class="icon-shuffle"></i> Sold</a>
                              </li>
                            </ul>
                          </li>
                        </ul>
                      </li>
                    </ul>
                  </td>
                </tr>
                <tr *ngIf="sales?.length <=0">
                  <td colspan="11" class="text-center"> <i class="icon-info22">&nbsp;</i>No Sales yet!</td>
                </tr>
              </tbody>
            </table>


            <div class="row">
              <!-- <p class="text-left" style="color:#00695C;font-weight:600;padding:10px;">{{val}}</p> -->
              <div class="text-center">

                <pagination-controls id="sales" (pageChange)="pageChanged(currentPage = $event)">
                </pagination-controls>

                <br>
              </div>

            </div>

          </fieldset>
        </div>


        <div class="col-md-5">


          <fieldset>
            <legend class="text-semibold">
              <i class="icon-reading position-left"></i> Sale Details
            </legend>

            <div class="row">
              <div class="col-lg-6">
                <div class="form-group required">
                  <span class="control-label"> Award: </span>
                  <ng-select [items]="awards" placeholder="" (change)="getWinner($event)" formControlName="award"
                    bindValue="id" bindLabel="text">
                  </ng-select>
                  <div class="help-block" *ngIf="award.invalid && (award.dirty || award.touched)">
                    <p class="text-danger">
                      <i class="icon-cancel-circle2 position-left text-red"></i> Award is required
                    </p>
                  </div>
                </div>
              </div>

              <div class="col-lg-6">
                <div class="form-group required">
                  <span class="control-label"> Seller: </span>
                  <input type="text" name="seller" required readonly formControlName="seller" class="form-control"
                    placeholder="ekub seller" [ngModel]="selectedSeller.name">
                  <div class="help-block" *ngIf="seller.invalid && (seller.dirty || seller.touched)">
                    <p class="text-danger">
                      <i class="icon-cancel-circle2 position-left text-red"></i> seller is required
                    </p>
                  </div>
                </div>
              </div>

            </div>
            <div class="row">
              <div class="col-lg-6">
                <div class="form-group required">
                  <span class="control-label"> Buyer: </span>
                  <ng-select [items]="ekubMembers" placeholder="" formControlName="buyer" bindValue="id"
                    bindLabel="username"></ng-select>
                  <!--  <div class="help-block" *ngIf="buyer.invalid && (buyer.dirty || buyer.touched)">
                    <p class="text-danger">
                      <i class="icon-cancel-circle2 position-left text-red"></i> buyer is required
                    </p>
                  </div> -->
                </div>
              </div>

              <div class="col-md-6">
                <div class="form-group required">
                  <span class="control-label">Transaction Date: </span>
                  <br>
                  <br>
                  <input type="date" name="title" formControlName="transaction_date" class="form-control"
                    placeholder="sale title">
                  <!-- <div class="help-block"
                    *ngIf="transaction_date.invalid && (transaction_date.dirty || transaction_date.touched)">
                    <p class="text-danger">
                      <i class="icon-cancel-circle2 position-left"></i>Transaction date is required.
                    </p>
                  </div> -->
                </div>
              </div>
            </div>

            <div class="row">


              <div class="col-md-4">
                <div class="form-group required">
                  <span class="control-label">Minimum Offer: </span>
                  <input type="number" name="min_offer" min="selectedAward" required formControlName="min_offer"
                    class="form-control" placeholder="sold price" (change)="calculateCommission($event)">
                  <div class="help-block" *ngIf="min_offer.invalid && (min_offer.dirty || min_offer.touched)">
                    <p class="text-danger">
                      <i class="icon-cancel-circle2 position-left"></i>Minimum offer is required.
                    </p>
                  </div>
                </div>
              </div>

              <div class="col-md-4">
                <div class="form-group required">
                  <span class="control-label">Sold Price: </span>
                  <input type="text" name="sold_price" formControlName="sold_price" class="form-control"
                    placeholder="sold price">
                  <!--  <div class="help-block" *ngIf="sold_price.invalid && (sold_price.dirty || sold_price.touched)">
                    <p class="text-danger">
                      <i class="icon-cancel-circle2 position-left"></i>Sold price is required.
                    </p>
                  </div> -->
                </div>

              </div>
              <div class="col-md-4">
                <div class="form-group required">
                  <span class="control-label">Deadline: </span>
                  <input type="date" name="deadline" formControlName="deadline" class="form-control"
                    required placeholder="deadline">
                  <div class="help-block" *ngIf="deadline.invalid && (deadline.dirty || deadline.touched)">
                    <p class="text-danger">
                      <i class="icon-cancel-circle2 position-left"></i>Ofer deadline is is required.
                    </p>
                  </div>
                </div>
              </div>
            </div>


            <div class="row">

              <div class="col-lg-4">
                <div class="form-group required">
                  <span class="control-label"> Commission Percentage: </span>
                  <input type="number" name="position" formControlName="commission_percentage" class="form-control"
                    placeholder="sale appearing position">
                  <!--  <div class="help-block"
                    *ngIf="commission_percentage.invalid && (commission_percentage.dirty || commission_percentage.touched)">
                    <p class="text-danger">
                      <i class="icon-cancel-circle2 position-left text-red"></i> commission percentage is required
                    </p>
                  </div> -->
                </div>
              </div>

              <div class="col-lg-4">
                <div class="form-group required">
                  <span class="control-label"> Commission Amount: </span>
                  <input type="number" name="commission_amount" formControlName="commission_amount" class="form-control"
                    placeholder="sale appearing position">
                  <!-- <div class="help-block"
                    *ngIf="commission_amount.invalid && (commission_amount.dirty || commission_amount.touched)">
                    <p class="text-danger">
                      <i class="icon-cancel-circle2 position-left text-red"></i> commission amount is required
                    </p>
                  </div> -->
                </div>
              </div>

              <div class="col-md-4">
                <div class="form-group required">
                  <span class="control-label">Status: </span>
                  <select name="status" required formControlName="status" class="form-control"
                    data-placeholder="Select offer status">
                    <option selected disabled>Status:</option>
                    <option value="pending">Pending</option>
                    <!--    <option value="active">Active</option> -->
                    <option value="sold">Sold</option>
                  </select>
                  <div class="help-block" *ngIf="status.invalid && (status.dirty || status.touched)">
                    <p class="text-danger">
                      <i class="icon-cancel-circle2 position-left"></i>Offer status is required.
                    </p>
                  </div>
                </div>
              </div>
            </div>


            <div class="row">

              <div class="form-group">
                <label>&nbsp;</label>
                <label>Remark:</label>
                <textarea rows="5" cols="5" class="form-control" name="remark" formControlName="remark"
                  placeholder="Additional information . . ." required></textarea>
                <div class="help-block" *ngIf="remark.invalid && (remark.dirty || remark.touched)">
                  <p class="text-danger">
                    <i class="icon-cancel-circle2 position-left"></i>Please write small description about the sale
                  </p>
                </div>
              </div>
            </div>

          </fieldset>

          <div class="text-right">

            <!--  <button class="btn bg-slate-800" (click)="addNews(sale.id)" type="submit" data-style="slide-right" [ladda]="isLoading" [disabled]="newsForm.invalid">
              <span *ngIf="!sale.id">Save News</span>
              <span *ngIf="sale.id">Update News</span>
              <i class="icon-floppy-disk position-right"></i>
            </button> -->
            <button class="btn bg-slate-800" (click)="addSale()" type="submit" data-style="slide-right"
              [disabled]="saleForm.invalid">
              <span *ngIf="operation=='add'">Save Sale</span>
              <span *ngIf="operation!='add'">Update Sale</span>
              <i class="icon-floppy-disk position-right"></i>
            </button>

          </div>


        </div>

      </div>





    </div>
  </div>
</form>
<!-- /2 columns form -->